const pageLength = (value) => {
  const length = typeof value === 'number' ? `${value}px` : String(value || '').trim()
  return /^(?:\d+(?:\.\d+)?|\.\d+)(?:mm|cm|in|px|pt|pc)$/i.test(length) && parseFloat(length) > 0
    ? length
    : null
}

export const getReportPrintPageCss = (layout = {}, isolated = false) => {
  // Match the rendered canvas dimensions, including custom and landscape pages.
  // An orientation alone leaves the browser's previous paper size in effect.
  const width = pageLength(layout.width)
  const height = pageLength(layout.height)
  const standard = ['A3', 'A4', 'A5', 'A6', 'Letter', 'Legal', 'Tabloid'].find(
    (size) => size.toLowerCase() === String(layout.size || '').toLowerCase(),
  ) || 'A4'
  const size = width && height
    ? `${width} ${height}`
    : `${standard} ${layout.orientation === 'landscape' ? 'landscape' : 'portrait'}`
  return `@page { size: ${size}; margin: 0; }${isolated ? `
html, body, #root {
  margin: 0 !important;
  padding: 0 !important;
  min-height: 0 !important;
  height: auto !important;
}
.print-report .print-page {
  padding: 0 !important;
  overflow: visible !important;
}` : ''}`
}
